import api from '@/api';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            mireraWay: '',
            piktomirPath: '',
            kumirPath: '',
            vkBot: ''
        };
    },

    computed: {
        ...mapGetters('user', [ 'profile' ]),

        mireraPath() {
            let route = this.profile ? `/${this.profile.permissions.mirera}` : '';

            return this.mireraWay + route;
        },

        mireraName() {
            if (!this.mireraWay)
                return '';

            const url = new URL(this.mireraWay);

            return url.host;
        },

        piktomirName() {
            if (!this.piktomirPath)
                return '';

            const url = new URL(this.piktomirPath);

            return url.host;
        }
    },

    created() {
        this.fetchData();
    },

    methods: {
        async fetchData() {
            let response = await api.get('/app/paths');
            this.mireraWay = response.data.mirera;
            this.piktomirPath = response.data.piktomir;
            this.kumirPath = response.data.kumir;
            this.vkBot = response.data.vkBot;
        }
    }
};
